<template>
  <patient-profile>
    <modal-dialog
      v-model="isSelectContractNumberModal"
      content-class="contract-number-modal"
      title="Выберите номер договора"
      with-cross
      max-width="600px"
    >
      <select-contract-number-modal
        ref="contractSelector"
        v-bind:contracts="patientContracts"
        v-on:submit="onSelectContractNumber"
        v-on:close="onCloseSelectModal"
      />
    </modal-dialog>
    <modal-dialog
      v-model="isShownNdflCertificateOptionForm"
      title="Справка для налоговой"
      with-cross
    >
      <circular-loader v-if="!isNdflOptionsLoaded" />
      <div v-else-if="ndflLegalNameError" class="patient-documents__ndfl-options__violation">
        <p class="patient-documents__ndfl-options__violation__text">{{ ndflLegalNameError }}</p>
        <router-link
          v-bind:to="{ name: 'ClinicPanelSettings' }"
          class="patient-documents__ndfl-options__violation__button"
        >
          Перейти в Настройки
        </router-link>
      </div>
      <form
        v-else
        class="patient-documents__ndfl-options"
        v-on:submit.prevent="onSubmitNdflCertificateOptionsForm"
      >
        <input-autocomplete
          v-if="isShowLegalNameList"
          v-bind:disabled="isSingleLegalNames"
          v-bind:options="ndflLegalNameList"
          v-bind:value="selectedNdflLegalName"
          v-on:input="onInputNdflLegalName"
          option-title-key="name"
          option-value-key="clinic_id"
          title="Организация"
          return-object
        />
        <input-autocomplete
          v-bind:options="ndflSignerList"
          v-model="selectedNdflSignerId"
          title="Подписант"
          no-data-text="Результатов нет"
        >
          <template v-slot:item="{ item }">
            <item-employee v-bind:name="item.name" v-bind:positions="item.role_name" />
          </template>
        </input-autocomplete>
        <div class="patient-documents__ndfl-options__list">
          <button
            class="patient-documents__ndfl-options__year"
            type="button"
            v-bind:class="{ selected: isSelected }"
            v-bind:key="year"
            v-for="{ year, isSelected } in reportingYears"
            v-on:click="selectedReportingYear = year">{{ year }}</button>
        </div>
        <div class="patient-documents__ndfl-options__list">
          <button
            class="patient-documents__ndfl-options__type"
            type="button"
            v-bind:class="{ selected: isSelected }"
            v-bind:key="value"
            v-for="{ name, value, isSelected } in reportingTypes"
            v-on:click="selectedReportingType = value">{{ name }}</button>
        </div>
        <router-link
          v-if="isNeedFillClinicFields"
          v-bind:to="{ name: 'ClinicPanelSettings' }"
          class="patient-documents__info-need-completed"
        >
          Необходимо заполнить ИНН для корректного формирования справки
        </router-link>
        <button
          class="patient-documents__button-make"
          type="submit">Сформировать</button>
      </form>
    </modal-dialog>
    <picker-items
      class="picker"
      content-class="documents-dialog"
      width="800px"
      v-bind:items="templatesWithPackages"
      title="Выберите документ"
      v-model="shownTemplatePicker"
      v-on:add="onAddTemplate"
      v-on:search="fetchTemplatesAndPackages"
      v-on:open="onResetBacklightTheButtons"
    >
      <template
        v-if="shownHeaderDocumentPicker"
        v-slot:header
      >
        <strong v-if="patientUnderFifteen" class="documents-dialog__warning">
          Для пациентов младше 15&nbsp;лет документы может подписывать только законный представитель
        </strong>
        <div v-if="hasBranchSystem" class="documents-dialog__general-document">
          <input-checkbox
            class="documents-dialog__checkbox"
            name="general-document"
            title="Сделать документ общим для всех филиалов"
            v-model="showAllBranches"
          />
          <div class="documents-dialog__help">
            <help-icon
              bottom
              type-icon="question"
              v-bind:max-width="260"
              v-bind:tooltip-text="$options.helpTextGlobalDocument"
              v-bind:sizes="{ width: 24, height: 24 }"
            />
          </div>
        </div>
      </template>
      <template
        v-slot:default="{
          item,
          emitAdd,
          onSelectSetColor,
        }">
        <button
          class="picker__item__button"
          type="button"
          :data-id="item.id"
          :data-type="item.type"
          v-on:click="emitAdd(item); onSelectSetColor($event)">
          <span>{{ item.getNameWithPrefix() }}</span>
        </button>
        <span>{{ item.typeName }}</span>
      </template>
    </picker-items>
    <div class="patient-documents">
      <iframe
        class="patient-documents__print"
        ref="pdfView"
        title="pdfView"
      />
      <button
        v-if="isShowInfo"
        class="patient-documents__info-need-completed button-action"
        type="button"
        v-bind:disabled="isAwaitRequest"
        v-on:click="showPatientPersonalData">
        Необходимо заполнить все личные данные пациента
      </button>
      <div class="patient-documents__buttons">
        <button
          class="patient-documents__button-make"
          type="button"
          v-on:click="onShowTemplatePickerDialog">Добавить документ</button>
        <button
          v-if="false"
          class="patient-documents__button-white"
          type="button"
          v-on:click="onShowNdflCertificateOptions">Справка для налоговой</button>
        <button
          v-if="false"
          type="button"
          class="patient-documents__button-white"
          v-on:click="toRegistryReference"
        >Реестр выданных справок</button>
      </div>
      <input-text-search
        class="patient-documents__search"
        v-bind:value="searchQuery"
        v-on:input="onInputSearchQuery"
        placeholder="Введите название документа"
      />
      <div class="patient-documents__table" v-if="isTemplateListNotEmpty">
        <div
          class="patient-documents__table__head"
          :class="{ 'with-status': isEmployeeLinked, 'without-status': !isEmployeeLinked }"
        >
          <input-sort
            class="patient-documents__table__cell sort"
            v-bind:class="{ selected: !!sortByDate }"
            v-bind:title="sortByDateTitle"
            v-bind:value="sortByDate"
            v-on:input="onSortByDate"
          >
            Дата создания
          </input-sort>
          <div class="patient-documents__table__cell">
            Название документа
          </div>
          <div class="patient-documents__table__cell">
            № Договора
          </div>
          <div
            v-if="isEmployeeLinked"
            class="patient-documents__table__cell">
            Статус
          </div>
        </div>
        <div
          v-bind:key="`${template.type}-${template.id}`"
          v-for="(template) in patientTemplates"
        >
          <div
            class="patient-documents__table__row"
            :class="{ 'with-status': isEmployeeLinked, 'without-status': !isEmployeeLinked }"
          >
            <div
              v-if="template.isContract"
              class="patient-documents__table__cell"
            >
              <input-date
                label-hidden
                label=""
                class="patient-documents__table__field-date"
                v-model="template.createdDate"
                max-width="100px"
                mask="дд.мм.гггг"
                variant="underlined"
                v-bind:violations="templateInputErrors[`template-${template.id}-date`]?.date"
                v-on:blur="updateContractTemplateDate(template.id, $event)"
              />
            </div>
            <div
              v-else
              class="patient-documents__table__cell"
            >
              {{ template.createdDate }}
            </div>
            <div class="patient-documents__table__cell">
              <template v-if="isPackageType(template.type)">
                <button
                  class="patient-documents__table__button-toggle"
                  :class="{ opened: isPackageOpened(template.id) }"
                  type="button"
                  v-on:click="togglePackage(template.id)"
                  :title="isPackageOpened(template.id) ? 'Скрыть документы' : 'Показать документы'"
                >
                  {{ template.name }}
                </button>
              </template>
              <template v-else>
                {{ template.name }}
              </template>
            </div>
            <div
              class="patient-documents__table__cell"
              v-bind:class="{ 'cell-documents-extended': template.isContract }">
              <label
                v-if="template.isContract"
                class="cell-documents-extended__label"
                data-sign="№"
              >
                <input
                  class="cell-documents-extended__input"
                  aria-label="Ввод номера"
                  type="text"
                  v-bind:min="1"
                  v-model="template.number"
                  v-on:blur="updateContractTemplateNumber(template.id, $event)"
                />
              </label>
            </div>
            <div
              v-if="isEmployeeLinked"
              class="patient-documents__table__cell">
              {{ template.status }}
            </div>
            <div class="patient-documents__table__cell patient-documents__table__buttons">
              <button
                v-if="isEmployeeLinked && !template.isSent"
                v-bind:disabled="isAwaitSignRequest"
                class="patient-documents__table__button-sign"
                :class="{
                  'patient-documents__table__button-sign--package':
                    isPackageType(template.type),
                }"
                title="Подписать"
                type="button"
                v-on:click="signFile(template.type, template)"
              >Подписать</button>
              <button
                class="patient-documents__table__button-download"
                :class="{
                  'patient-documents__table__button-download--package': isPackageType(
                    template.type,
                  ),
                }"
                :disabled="isAwaitDownloadAttachedPackageDocuments"
                title="Скачать"
                type="button"
                v-on:click="downloadFile(template)"
              />
              <button
                v-if="!isMobile && !isPackageType(template.type)"
                class="patient-documents__table__button-print"
                title="Печать"
                type="button"
                v-on:click="printFile(template.isContract, template)"
              />
            </div>
            <div class="patient-documents__table__cell">
              <template v-if="!isMobile">
                <button
                  v-bind:disabled="!template.isStatusFinal"
                  class="patient-documents__table__button-delete"
                  v-bind:title="getDeleteTitle(template)"
                  type="button"
                  v-on:click="deleteDocument(template)"
                />
              </template>
              <template v-else>
                <button
                  v-if="template.isStatusFinal"
                  class="patient-documents__table__button-delete"
                  type="button"
                  v-on:click="deleteDocument(template)"
                />
                <button
                  v-else
                  class="patient-documents__table__button-delete__disabled-grey"
                  type="button"
                  v-on:click="showMessageCantDelete()"
                />
              </template>
            </div>
          </div>
          <template v-if="isPackageOpened(template.id)">
            <div
              class="patient-documents__table__row"
              :class="{ 'with-status': isEmployeeLinked, 'without-status': !isEmployeeLinked }"
              v-for="(attachedDocument) in template.attachedDocuments"
              v-bind:key="`${attachedDocument.type}-${attachedDocument.id}`"
            >
              <div
                v-if="attachedDocument.isContract"
                class="patient-documents__table__cell"
              >
                <input-date
                  label-hidden
                  label=""
                  class="patient-documents__table__field-date"
                  v-model="attachedDocument.createdDate"
                  max-width="100px"
                  mask="дд.мм.гггг"
                  variant="underlined"
                  v-bind:violations="templateInputErrors[`template-${attachedDocument.id}-date`]?.date"
                  v-on:blur="updateContractTemplateDate(attachedDocument.id, $event)"
                />
              </div>
              <div
                v-else
                class="patient-documents__table__cell"
              >
                {{ attachedDocument.createdDate }}
              </div>
              <div class="patient-documents__table__cell padding">{{ attachedDocument.name }}</div>
              <div
                class="patient-documents__table__cell"
                v-bind:class="{ 'cell-documents-extended': attachedDocument.isContract }">
                <label
                  v-if="attachedDocument.isContract"
                  class="cell-documents-extended__label"
                  data-sign="№"
                >
                  <input
                    class="cell-documents-extended__input"
                    aria-label="Ввод номера"
                    type="text"
                    v-bind:min="1"
                    v-model="attachedDocument.number"
                    v-on:blur="updateContractTemplateNumber(attachedDocument.id, $event)"
                  />
                </label>
                <div v-else>
                  <select-attached-document-contract-number
                    v-if="attachedDocument.isNeedContractNumber"
                    v-bind:contracts="patientContracts"
                    v-on:on_select_contract_number="onSelectedContractNumberForAttachedDocument(
                      attachedDocument, $event,
                    )"
                  />
                </div>
              </div>
              <div />
              <div class="patient-documents__table__cell patient-documents__table__buttons">
                <button
                  class="patient-documents__table__button-download"
                  title="Скачать"
                  type="button"
                  v-on:click="downloadFile(attachedDocument)"
                />
                <button
                  v-if="!isMobile && !isPackageType(attachedDocument.type)"
                  class="patient-documents__table__button-print"
                  title="Печать"
                  type="button"
                  v-on:click="printFile(attachedDocument.isContract, attachedDocument)"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
      <support-contacts
        v-else-if="!isAwaitRequest"
        class="patient-documents__support"
        v-bind:title="titleSupportContacts"
        v-bind:is-show-mini-button-whats-app="true"
        v-bind:is-show-large-button-whats-app="false"
      />
    </div>
    <side-slide-transition>
      <side-dialog
        v-if="showForm"
        v-on:cancel="showForm = false"
        label="Персональные данные пациента">
        <form
          class="patient-documents__form"
          v-on:submit.prevent="onSubmit">
          <form-identification
            v-on:on-model-update="onUpdateIdentification"
            init-iin=''
            :input-errors=inputErrors
            :init-identification=identification
            :is-show-inn="false"
            :is-show-iin="false"
          />
          <div class="patient-documents__form__buttons">
            <button
              class="patient-documents__form__button-cancel"
              type="button"
              v-on:click="showForm = false">Отмена</button>
            <button
              class="patient-documents__form__button-submit"
              type="submit"
              v-bind:disabled="isAwaitRequest">Сохранить</button>
          </div>
        </form>
      </side-dialog>
    </side-slide-transition>
  </patient-profile>
</template>

<script>
import { List } from 'monet';
import notifierMixin from '@/mixins/notifierMixin';
import saveFileMixin from '@/mixins/saveFileMixin';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import SideDialog from '@/components/SideDialog.vue';
import {
  EditPatientIdentificationForeignPasswordRequest,
  EditPatientIdentificationRequest,
  Identification,
} from '@/storage/gateways/PatientGateway';
import SupportContacts from '@/components/SupportContacts.vue';
import PatientProfile from '@/views/ClinicPanel/PatientProfile.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import mobileMixin from '@/mixins/mobileMixin';
import InputTextSearch from '@/components/InputTextSearch.vue';
import debounce from 'lodash.debounce';
import FormIdentification from '@/components/FormIdentification.vue';
import PickerItems from '@/components/PickerItems.vue';
import { builtInDialogMixin, DialogResult } from '@/components/ClinicPanelDialog.vue';
import SelectContractNumberModal from '@/components/SelectContractNumberModal.vue';
import InputSort from '@/components/InputSort.vue';
import InputCheckbox from '@/components/InputCheckbox.vue';
import HelpIcon from '@/components/HelpIcon.vue';
import metricMixin from '@/mixins/metricMixin';
import {
  GOAL_ADD_DOCUMENT_PATIENT_DOCUMENTS,
  GOAL_CLICK_DOCUMENT_REFERENCE_ELECTRON_TAX_PATIENT_DOCUMENTS,
  GOAL_CLICK_DOCUMENT_REFERENCE_TEXT_TAX_PATIENT_DOCUMENTS,
  GOAL_CLICK_REGISTRY_REFERENCES_PATIENT_DOCUMENTS,
  GOAL_SEARCH_BY_DOCUMENTS_PATIENT_DOCUMENTS,
} from '@/plugins/metric';
import InputDate from '@/components/InputDate.vue';
import ItemEmployee from '@/components/ItemEmployee.vue';
import dateMixin from '@/mixins/dateMixin';
import InputAutocomplete from '@/components/InputAutocomplete.vue';
import CircularLoader from '@/components/CircularLoader.vue';
import SelectAttachedDocumentContractNumber
  from '../../components/SelectAttachedDocumentContractNumber.vue';
import {
  AttachedDocument, PatientTemplate,
} from '../../storage/gateways/DocumentTemplateGateway';

/**
 * @description Название события выбран номер договора.
 * @type {string}
 */
const NAME_EVENT_SELECTED_CONTRACT_NUMBER = 'on-selected-contract-number';

/**
 * Тип документа - Пакет документов
 *
 * @type {string}
 */
const DOCUMENT_TYPE_PACKAGE = 'package';

/**
 * Тип документа - Документ
 *
 * @type {string}
 */
const DOCUMENT_TYPE_DOCUMENT = 'document';

/**
 * Тип документа - Договор(Контракт)
 *
 * @type {string}
 */
const DOCUMENT_TYPE_CONTRACT = 'contract';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);
/**
 * @description Текст кнопки помощи - "Доступность документа для филиалов".
 * @type {string}
 */
const helpTextGlobalDocument = 'Документ будет доступен во всех филиалах и иметь юридическую силу в каждом их них.';

/**
 * @description Примесь формы справки НДФЛ.
 * @type {object}
 */
const formNdlMixin = {
  ndflTypeXml: 'xml',
  ndflTypeDoc: 'doc',
  computed: {
    reportingYears() {
      return this
        .reportingYearList
        .map((year) => ({ year, isSelected: year === this.selectedReportingYear }));
    },
    reportingTypes() {
      return this
        .reportingTypeList
        .map(
          ({ name, value }) => ({ name, value, isSelected: value === this.selectedReportingType }),
        );
    },
    isSingleLegalNames() {
      return this.ndflLegalNameList.length === 1;
    },
    isShowLegalNameList() {
      return this.ndflLegalNameTags.indexOf('hide_legal_names') === -1;
    },
    isNeedFillClinicFields() {
      return this.ndflLegalNameTags.includes('need_fill_clinic_inn');
    },
  },
  data() {
    return {
      isShownNdflCertificateOptionForm: false,
      /**
       * @description Показывать ли модалку с выбором номера договора.
       * @type {boolean}
       */
      isSelectContractNumberModal: false,
      /**
       * @description Id шаблона.
       * @type {string}
       */
      templateId: '',
      reportingYearList: [],
      selectedReportingYear: '',
      selectedReportingType: this.$options.ndflTypeDoc,
      /**
       * @description Удостоверение личности.
       * @type {Identification}
       */
      identification: new Identification(),
      isShownContextContractsDialog: false,
      reportingTypeList: [
        {
          name: 'Текстовый',
          value: this.$options.ndflTypeDoc,
        },
        {
          name: 'Электронный',
          value: this.$options.ndflTypeXml,
        },
      ],
      ndflLegalNameList: [],
      selectedNdflLegalName: null,
      ndflSignerList: [],
      ndflLegalNameTags: [],
      selectedNdflSignerId: null,
      isNdflOptionsLoaded: false,
      ndflLegalNameError: '',
    };
  },
  methods: {
    /**
     * @description Получить опции для формировании справки НДФЛ.
     * @returns {void}
     */
    onShowNdflCertificateOptions() {
      const date = new Date();
      const currentYear = date.getFullYear();
      const years = [];
      for (let i = 3; i >= 0; i -= 1) {
        years.push(currentYear - i);
      }
      this.reportingYearList = years;
      this.selectedReportingYear = currentYear;
      this.isNdflOptionsLoaded = false;
      this.fetchNdflOptions(this.patientId);
      this.isShownNdflCertificateOptionForm = true;
    },
    fetchNdflOptions(patientId) {
      const onFail = (error) => {
        this.isNdflOptionsLoaded = true;
        if (error.has('inn')) {
          this.ndflLegalNameError = error.allCauses().inn.join(',');
          return;
        }
        this.notifyFail(error.title);
      };
      const onSuccess = (response) => {
        this.isNdflOptionsLoaded = true;
        this.ndflLegalNameTags = response.tags;
        this.ndflLegalNameList = response.legal_names;
        if (this.ndflLegalNameList.length > 0) {
          this.selectedNdflLegalName = this.ndflLegalNameList[response.default_legal_name_index];
          this.ndflSignerList = this.selectedNdflLegalName.signers;
          this.selectedNdflSignerId = this.selectedNdflLegalName.default_signer_id;
        }
      };
      this
        .$registryNdflCertificateGateway
        .viewFormOptions(patientId)
        .then((result) => result.fold(onFail, onSuccess));
    },
    onInputNdflLegalName(legalName) {
      if (legalName === null) {
        return;
      }
      this.selectedNdflLegalName = legalName;
      this.ndflSignerList = legalName.signers;
      this.selectedNdflSignerId = legalName.default_signer_id;
    },
    /**
     * @description Обработать отправку формы с опциями для формировании справки НДФЛ.
     * @returns {void}
     */
    onSubmitNdflCertificateOptionsForm() {
      this.isShownNdflCertificateOptionForm = false;
      this.reachReferenceTaxGoal();
      const query = {
        signer_id: this.selectedNdflSignerId,
        clinic_id: this.selectedNdflLegalName.clinic_id,
        year: this.selectedReportingYear,
        type: this.selectedReportingType,
      };
      this.$router.push({
        name: 'ClinicPanelNdflCertificateCreation',
        params: { id: this.patientId },
        query,
      });
    },
    /**
     * @description Достичь цели - клик по справке о доходах
     * @returns {void}
     */
    reachReferenceTaxGoal() {
      if (this.selectedReportingType === 'doc') {
        this.reachGoalIfNotReach(GOAL_CLICK_DOCUMENT_REFERENCE_TEXT_TAX_PATIENT_DOCUMENTS);
      }
      if (this.selectedReportingType === 'xml') {
        this.reachGoalIfNotReach(GOAL_CLICK_DOCUMENT_REFERENCE_ELECTRON_TAX_PATIENT_DOCUMENTS);
      }
    },
  },
};

/**
 * @description Примесь шаблонов документов.
 * @type {object}
 */
const templatesMixin = {
  computed: {
    templatesWithPackages() {
      return [...this.templates, ...this.packages];
    },
  },
  data() {
    return {
      shownTemplatePicker: false,
      /**
       * @description Список шаблонов.
       * @type []
       */
      templates: [],
      /**
       * @description Список шаблонных Пакетов документов/контрактов
       * @type []
       */
      packages: [],
      /**
       * @description Список удаленных шаблонов.
       * @type []
       */
      deleteTemplates: [],
      /**
       * @description Отображать на всех филиалах.
       * @type {boolean}
       */
      showAllBranches: false,
    };
  },
  methods: {
    /**
     * Выполнить получение Шаблонов и Пакетов.
     * @param search
     */
    fetchTemplatesAndPackages(search = '') {
      this.fetchTemplates(search);
      this.fetchPackages(search);
    },
    /**
     * @description К реестру справок
     * @returns {void}
     */
    toRegistryReference() {
      this.reachGoalIfNotReach(GOAL_CLICK_REGISTRY_REFERENCES_PATIENT_DOCUMENTS);
      this.$router.push(this.navigationToRegistry);
    },
    /**
     * @description Обработать показ модального окна выбора шаблонов.
     * @returns {void}
     */
    onShowTemplatePickerDialog() {
      this.shownTemplatePicker = true;
      this.reachGoalIfNotReach(GOAL_ADD_DOCUMENT_PATIENT_DOCUMENTS);
    },
    /**
     * @description Отключить подсветку у удаленных документов.
     * @param {function} resetColorCb Обратный вызов.
     * @returns {void}
     */
    onResetBacklightTheButtons(resetColorCb) {
      this.deleteTemplates?.forEach(({ id, type }) => {
        const buttonSelector = `.picker__item__button[data-id="${id}"][data-type="${type}" i] span`;
        resetColorCb(buttonSelector);
      });
      this.deleteTemplates.length = 0;
    },
    /**
     * @description Получить список шаблонов.
     * @param {string} search
     * @returns {void}
     */
    fetchTemplates(search = '') {
      this
        .$documentTemplateGateway
        .viewList(
          search,
        ).then((result) => {
          result.forEach((templates) => {
            this.templates = templates;
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
          });
        });
    },

    /**
     * @description Получить список шаблонных Пакетов документов. Для их отображения
     * в модальном окне выбора шаблонов для их дальнейшего закрепления за пациентом.
     * @param {string} search
     * @returns {void}
     */
    fetchPackages(search = '') {
      this
        .$documentTemplateGateway
        .viewPackageList(
          search,
        ).then((result) => {
          result.forEach((packages) => {
            this.packages = packages.map((pkg) => ({
              id: pkg.id,
              name: pkg.name,
              type: DOCUMENT_TYPE_PACKAGE,
              typeName: 'Пакет',
              isSample: false,
              getNameWithPrefix() {
                return `${this.name}`;
              },
            }));
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
          });
        });
    },

    /**
     * @description Обработать добавление шаблона документа на пациента.
     * @param item
     * @returns {Promise<void>}
     */
    async onAddTemplate(item) {
      const patientTemplate = this
        .patientTemplates
        .find(
          (template) => template.type === item.type && template.name === item.name,
        ).orNull();
      if (patientTemplate !== null) {
        const dialog = await this.showAcceptDialog('Данный документ уже прикреплен к пациенту. Продолжить?');
        if (dialog.result !== DialogResult.YES) {
          return;
        }
      }
      if (item.type !== DOCUMENT_TYPE_PACKAGE) {
        if (item.isSample) {
          this
            .$documentTemplateGateway
            .addPatientTemplateBySample(
              this.patientId,
              item.id,
              item.type,
              this.showAllBranches,
            ).then((result) => {
              result.forEach((response) => {
                this.notifySuccess(response.message);
                this.fetchPatientTemplates();
              });
              result.forEachLeft((error) => {
                this.notifyFail(error.getTitle());
              });
            });
        } else {
          this
            .$documentTemplateGateway
            .addPatientTemplate(
              this.patientId,
              item.id,
              item.type,
              this.showAllBranches,
            ).then((result) => {
              result.forEach((response) => {
                this.notifySuccess(response.message);
                this.fetchPatientTemplates();
              });
              result.forEachLeft((error) => {
                this.notifyFail(error.getTitle());
              });
            });
        }
      } else {
        this
          .$documentTemplateGateway
          .addPatientPackage(
            this.patientId,
            item.id,
            item.type,
            this.showAllBranches,
          ).then((result) => {
            result.forEach((response) => {
              this.notifySuccess(response.message);
              this.fetchPatientTemplates();
            });
            result.forEachLeft((error) => {
              this.notifyFail(error.getTitle());
            });
          });
      }
    },
  },
};

export default {
  computed: {
    isPackageType() {
      return (type) => type === DOCUMENT_TYPE_PACKAGE;
    },
    addressInputErrors: resolveInputErrors('address'),
    medicalCardNumberErrors: resolveInputErrors('medical-card-number'),
    passportNumberErrors: resolveInputErrors('passport-number'),
    passportSerialErrors: resolveInputErrors('passport-serial'),
    passportWhoIssuedErrors: resolveInputErrors('passport-who-issued'),
    patientId: ({ $route }) => $route.params.id,
    phoneErrors: resolveInputErrors('phone'),
    isShowInfo({ arePersonalDataRequired, isAwaitCheckPersonalDataRequest }) {
      return !isAwaitCheckPersonalDataRequest && arePersonalDataRequired;
    },
    sortByDateTitle() {
      if (!this.sortByDate) {
        return 'Отсортировать по дате';
      }
      if (this.sortByDate === 'asc') {
        return 'Отсортировать по дате в обратном порядке';
      }
      return 'Без сортировки';
    },
    /**
     * @description Отображать заголовок в выборе документа.
     * @returns {boolean}
     */
    shownHeaderDocumentPicker() {
      return this.patientUnderFifteen || this.hasBranchSystem;
    },
    /**
     * @description Имеется филиальная система.
     * @returns {boolean}
     */
    hasBranchSystem() {
      return this.$store.getters.isSectionAvailable('branch-system');
    },
    /**
     * @description Договора пациента.
     * @returns {Array}
     */
    patientContracts() {
      const contracts = this.patientTemplates.toArray()
        .filter((item) => item.isContract)
        .map((item) => ({
          value: item.id,
          title: item.number,
        }));
      const packageContracts = this.patientTemplates.toArray()
        .filter((item) => item.attachedDocuments && item.attachedDocuments.length > 0)
        .flatMap((packageItem) => packageItem.attachedDocuments
          .filter((doc) => doc.type === DOCUMENT_TYPE_CONTRACT || doc.isContract)
          .map((doc) => ({
            value: doc.id,
            title: doc.number,
          })));
      return [...contracts, ...packageContracts]
        .sort((a, b) => a.title - b.title);
    },
    /**
     * @description Список шаблонов не пустой.
     * @type {boolean}
     */
    isTemplateListNotEmpty: ({ isAwaitRequest, patientTemplates }) => (
      !isAwaitRequest && patientTemplates.size() !== 0
    ),
    /**
     * @description Навигация до реестра справок.
     */
    navigationToRegistry() {
      return {
        name: 'ClinicPanelRegistryNdflCertificateList',
        params: {
          initialPatientId: +this.patientId,
        },
      };
    },
    /**
     * @description Маска ввода серии.
     * @returns {string[]|function}
     */
    serialMask(self) {
      if (self.identification.type === 'passport') {
        return '## ##';
      }
      if (self.identification.type === 'birth_certificate') return 'XXXXXXX';
      return 'XXXXXXX';
    },
    identificationTypeInputError: resolveInputErrors('identification.type'),
    innInputErrors: resolveInputErrors('identification.inn'),
    livingAddressInputError: resolveInputErrors('identification.livingAddress'),
    numberInputError: resolveInputErrors('identification.number'),
    serialInputError: resolveInputErrors('identification.serial'),
    whenIssuedInputError: resolveInputErrors('identification.when_issued'),
    whoIssuedInputError: resolveInputErrors('identification.who_issued'),
    addressInputError: resolveInputErrors('identification.address'),
    templateInputErrors() {
      const errors = {};
      this.patientTemplates.forEach((template) => {
        const index = `template-${template.id}-date`;
        const date = this.inputErrors[index] ?? [];
        errors[index] = {
          date,
        };
      });
      return errors;
    },
  },
  components: {
    SelectAttachedDocumentContractNumber,
    CircularLoader,
    SelectContractNumberModal,
    FormIdentification,
    InputTextSearch,
    ItemEmployee,
    ModalDialog,
    PatientProfile,
    SideDialog,
    SideSlideTransition,
    SupportContacts,
    PickerItems,
    InputAutocomplete,
    InputSort,
    InputCheckbox,
    HelpIcon,
    InputDate,
  },
  created() {
    this.checkPersonalDataCompleteness();
    this.fetchPatientTemplates();
    this.fetchTemplates();
    this.fetchPackages();
  },
  data() {
    return {
      /**
       * @description Необходимо заполнить все личные данные пациента.
       * @type {boolean}
       */
      arePersonalDataRequired: false,
      sortByDate: '',
      /**
       * @description Список шаблонов пациентов.
       * @type {List<PatientTemplate>}
       */
      patientTemplates: List(),
      /**
       * @description Показывать форму заполнения личных данных пациента.
       * @type {boolean}
       */
      showForm: false,
      /**
       * @description Пациент младше 15.
       * @type {null|Object}
       */
      patientUnderFifteen: false,
      personal: {
        address: '',
        medicalCardNumber: '',
        passportNumber: '',
        passportSerial: '',
        passportWhoIssued: '',
        phone: '',
      },
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isAwaitSignRequest: false,
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Ожидание завершения запроса проверки заполненности личных данных.
       * @type {boolean}
       */
      isAwaitCheckPersonalDataRequest: false,
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description Заголовок блока контактов поддержки.
       * @type {string}
       */
      titleSupportContacts: 'Для автозаполнения и скачивания документов отправьте нам шаблоны '
        + 'документов вашей клиники (договор, согласие на обработку персональных данных и т.д.), '
        + 'мы сами загрузим их в МИС. \n\n Менеджер сопровождения',
      /**
       * @description Удостоверение личности.
       * @type {Identification}
       */
      identification: new Identification(),
      searchQuery: '',
      /**
       * @description Флаг. Имеет ли пациент заполненный номер телефона
       */
      isPatientPhoneExists: false,
      /**
       * @description Флаг. Имеет ли сотрудник мис линковку с сотрудником Fdoc
       */
      isEmployeeLinked: false,
      openedPackages: new Set(),
      /**
       * @description Флаг. Ожидания скачивания вложенных в Пакет документов.
       */
      isAwaitDownloadAttachedPackageDocuments: false,
    };
  },
  methods: {
    debounceFetchPatientTemplates: debounce(function _() { this.fetchPatientTemplates(); }, 300),
    /**
     * @description Обработать выставление номера договора для вложенного в Пакет Документа
     * @param document
     * @param contractNumber
     */
    onSelectedContractNumberForAttachedDocument(document, contractNumber) {
      document.setContractNumberForDocument(contractNumber);
    },
    /**
     * Получение заголовка для кнопки Удалить в зависимости от статуса документа.
     *
     * @param {PatientTemplate} template
     * @return {string}
     */
    getDeleteTitle(template) {
      return template.isStatusFinal
        ? 'Удалить'
        : 'Документ в статусе "Ожидает подписи" удалить невозможно';
    },
    /**
     * @description Переключатель для открытия/закрытия Пакетов
     * @param packageId
     */
    togglePackage(packageId) {
      if (this.openedPackages.has(packageId)) {
        this.openedPackages.delete(packageId);
      } else {
        this.openedPackages.add(packageId);
      }
      this.$set(this, 'openedPackages', new Set(this.openedPackages));
    },
    /**
     * Раскрыт ли Пакет документов
     * @param packageId
     * @return {boolean}
     */
    isPackageOpened(packageId) {
      return this.openedPackages.has(packageId);
    },
    /**
     * @description Обработать сортировку по дате.
     * @param {string} order
     * @returns {void}
     */
    onSortByDate(order) {
      this.sortByDate = order;
      this.debounceFetchPatientTemplates();
    },
    /**
     * @description Обработать событие выбора номера договора.
     * @param {number} contractNumber
     * @returns {void}
     */
    onSelectContractNumber(contractNumber) {
      this.$emit(NAME_EVENT_SELECTED_CONTRACT_NUMBER, contractNumber);
      this.onCloseSelectModal();
    },
    /**
     * @description Обработать событие закрытия модального окна.
     * @returns {void}
     */
    onCloseSelectModal() {
      this.isSelectContractNumberModal = false;
    },
    /**
     * @description Обновление удостоверения личности
     * @param newIdentification {Identification}
     */
    onUpdateIdentification(newIdentification) {
      this.identification = newIdentification;
    },
    /**
     * @description Маска мед. карты.
     * @returns {void}
     */
    cardNumberMask(value) {
      return [value.replace(/[^0-9-—/]/, '').substring(0, 20)];
    },
    /**
     * @description Проверить заполненность личных данных пациента.
     * @returns {void}
     */
    checkPersonalDataCompleteness() {
      this.isAwaitCheckPersonalDataRequest = true;
      this.$patientGateway.checkIdentificationCompleteness(this.patientId).then((result) => {
        result.forEach((list) => {
          this.arePersonalDataRequired = list.length !== 0;
        });
        this.isAwaitCheckPersonalDataRequest = false;
      });
    },
    /**
     * @description Скачать выбранный файл.
     * @param {Object} template Документ.
     * @returns {void}
     */
    downloadFile(template) {
      const fileType = template.type;
      switch (fileType) {
        case DOCUMENT_TYPE_DOCUMENT: this.onClickDownloadDocumentButton(template); break;
        case DOCUMENT_TYPE_PACKAGE: this.downloadPackageDocuments(template); break;
        case DOCUMENT_TYPE_CONTRACT: this.downloadContract(template); break;
        default:
      }
    },
    /**
     * @description Скачать все вложенные в Пакет документы.
     *
     * @param template
     * @return {Promise<void>}
     */
    downloadPackageDocuments(template) {
      if (!template.hasAllContractNumbersFilled()) {
        this.notifyFail('Укажите № Договора для всех документов Пакета!');
        return;
      }
      if (this.isAwaitDownloadAttachedPackageDocuments === true) {
        return;
      }
      this.isAwaitDownloadAttachedPackageDocuments = true;
      const onSuccess = (response) => {
        this.saveArchive(response, `${template.name}.zip`);
      };
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const { templateId } = template;
      this
        .$patientGateway
        .generatePackageDocumentsFromTemplateForDownload(this.patientId, templateId, template)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitDownloadAttachedPackageDocuments = false; });
    },
    /**
     * @description Скачать договор.
     * @param {Object} template Шаблон договора.
     * @returns {void}
     */
    async downloadContract(template) {
      const { id } = template;
      const { templateId } = template;
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = (response) => {
        const currentTemplate = this.patientTemplates.find((item) => item.id === id);
        const name = currentTemplate.fold('Договор')((item) => item.name);
        this.saveFile(response, `${name}.doc`);
        this.fetchPatientTemplates();
      };
      const response = await this.$patientGateway.generateContractFromTemplateForDownload(
        this.patientId,
        templateId,
        template.number,
      );
      response.fold(onFail, onSuccess);
    },
    /**
     * @description Скачать документы.
     * @param {Object} template   Шаблон.
     * @param {string} contractId Идентификатор договора.
     * @returns {void}
     */
    async downloadDocument(template, contractId = '') {
      const { id } = template;
      const { templateId } = template;
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = (response) => {
        const currentTemplate = this.patientTemplates.find((item) => item.id === id);
        const name = currentTemplate.fold('Документ')((item) => item.name);
        this.saveFile(response, `${name}.doc`);
      };
      const response = await this.$patientGateway.generateDocumentFromTemplateForDownload(
        this.patientId,
        templateId,
        contractId,
      );
      response.fold(onFail, onSuccess);
    },
    /**
     * @description Сформировать документ и отправить на подписание.
     * @param {Object} template   Шаблон.
     * @param {string} contractId Идентификатор договора.
     * @returns {void}
     */
    async generateDocumentAndSign(template, contractId = '') {
      const onSuccess = (response) => {
        this.notifySuccess(response.title);
        this.fetchPatientTemplates();
      };
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      this.isAwaitSignRequest = true;
      try {
        const response = await this.$fDocIntegrationGateway.generateDocumentFromTemplateForSign(
          template.id,
          contractId,
        );
        response.fold(onFail, onSuccess);
      } finally {
        this.isAwaitSignRequest = false;
      }
    },
    /**
     * @description Получить список шаблонов по пациенту.
     * @returns {void}
     */
    fetchPatientTemplates() {
      this.isAwaitRequest = true;
      this
        .$documentTemplateGateway
        .viewPatientList(
          this.patientId,
          this.searchQuery,
          this.sortByDate,
        ).then((result) => {
          result.forEach(({
            list, patientUnderFifteen, isPatientPhoneExists, isEmployeeLinked,
          }) => {
            const templates = list.map((item) => this.createPatientTemplateFromApi(item));
            this.patientTemplates = List.fromArray(templates);
            this.patientUnderFifteen = patientUnderFifteen;
            this.isPatientPhoneExists = isPatientPhoneExists;
            this.isEmployeeLinked = isEmployeeLinked;
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
          });
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Создать PatientTemplate из сырых данных API
     * @param {Object} data - Сырые данные от API
     * @returns {PatientTemplate}
     */
    createPatientTemplateFromApi(data) {
      const attachedDocuments = (data.attached_documents || []).map((doc) => new AttachedDocument(
        doc.id,
        doc.template_id,
        doc.name,
        doc.is_contract,
        doc.is_need_contract_number,
        doc.number,
        doc.type,
        doc.created_date,
      ));
      return new PatientTemplate(
        data.id,
        data.name,
        data.is_contract,
        data.type,
        data.created_date,
        data.template_id,
        data.number,
        data.is_sent,
        data.is_status_final,
        data.status,
        data.package_need_contract_number,
        data.type_name,
        data.is_has_number_contract_variable,
        attachedDocuments,
      );
    },
    /**
     * @description Обработать ввод запроса.
     * @type {string} value
     * @returns {void}
     */
    onInputSearchQuery(value) {
      this.searchQuery = value;
      this.reachGoalIfNotReach(GOAL_SEARCH_BY_DOCUMENTS_PATIENT_DOCUMENTS);
    },
    /**
     * @description Обработать сохранение персональных данных пациента.
     * @returns {void}
     */
    onSubmit() {
      this.isAwaitRequest = true;
      const onSuccess = (response) => {
        this.notifySuccess(response);
        this.inputErrors = {};
        this.showForm = false;
        this.checkPersonalDataCompleteness();
      };
      const onFail = (error) => {
        if (error.causes && error.causes.length > 0) {
          this.notifyFail('Не удалось отправить данные, проверьте правильность заполнения');
          const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
          this.inputErrors = Object.fromEntries(failurePairs);
        } else {
          this.notifyFail(error.title);
        }
      };
      if (this.identification.type === 'foreign-passport') {
        this.sendIdentificationForeignPasswordEditRequest()
          .then((result) => result.fold(onFail, onSuccess))
          .finally(() => {
            this.isAwaitRequest = false;
          });
        return;
      }
      this.sendIdentificationEditRequest()
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обновить номер шаблона договора.
     * @param templateId
     * @param event
     */
    updateContractTemplateNumber(templateId, event) {
      const number = event.target.value;
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = () => {
        this.inputErrors = {};
        this.fetchPatientTemplates();
      };
      const response = this.$patientGateway.editContractTemplateNumber(
        this.patientId,
        templateId,
        number,
      );
      response.then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обновить дату шаблона договора.
     * @param templateId
     * @param event
     */
    updateContractTemplateDate(templateId, event) {
      const date = this.formatDateToISO(event);
      const onFail = (error) => {
        if (!error.has(`template-${templateId}-date`)) {
          this.notifyFail(error.getTitle());
        }
        this.inputErrors = { ...this.inputErrors, ...error.allCauses() };
      };
      const onSuccess = ({ title }) => {
        this.notifySuccess(title);
        this.inputErrors = {};
        this.fetchPatientTemplates();
      };
      const response = this.$patientGateway.editContractTemplateDate(
        this.patientId,
        templateId,
        date,
      );
      response.then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Печать выбранного файла.
     * @param {bool} isContract Тип документа.
     * @param {Object} template Документ.
     * @returns {void}
     */
    printFile(isContract, template) {
      if (isContract) {
        this.printContract(template);
      } else {
        this.onClickPrintDocumentButton(template);
      }
    },
    /**
     * @description Печать договора.
     * @param {Object} template Шаблон договора.
     * @returns {void}
     */
    async printContract(template) {
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = (response) => {
        const container = this.$refs.pdfView;
        container.setAttribute('src', URL.createObjectURL(response));
        container.onload = () => {
          container.contentWindow.print();
        };
        this.fetchPatientTemplates();
      };
      const response = await this.$patientGateway.generateContractFromTemplateForPrint(
        this.patientId,
        template.templateId,
        template.number,
      );
      response.fold(onFail, onSuccess);
    },
    /**
     * @description Добавить данные удаленного документа.
     * @param {number} template_id Идентификатор документа.
     * @param {string} name Наименование документа.
     * @param {string} name Тип документа.
     * @returns {void}
     */
    pushDeletedDocument({ template_id: id, name, type }) {
      this.deleteTemplates.push({ id, name, type });
    },
    /**
     * @description Удалить документ пациента
     *
     * @param {Object} template
     *
     * @returns {Promise<void>}
     */
    async deleteDocument(template) {
      if (template.isContract) {
        const dialog = await this.showAcceptDialog('Для отправки данных в ЕГИСЗ необходим номер Договора. Удалить документ?');
        if (dialog.result !== DialogResult.YES) {
          return;
        }
      } else {
        const dialog = await this.showAcceptDialog('Вы действительно хотите удалить документ?');
        if (dialog.result !== DialogResult.YES) {
          return;
        }
      }
      const onFail = (error) => {
        this.notifyFail(error.message);
      };
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.fetchPatientTemplates();
        this.pushDeletedDocument(template);
      };
      const response = await this
        .$documentTemplateGateway
        .deletePatientTemplate(this.patientId, template.id, template.type);
      response.fold(onFail, onSuccess);
    },
    /**
     * @description Получение сообщение причины невозможности удаления документа
     */
    showMessageCantDelete() {
      this.notifyFail('Документ в статусе "Ожидает подписи" удалить невозможно');
    },
    /**
     * @description Обработать событие нажатия на кнопку печати.
     * @param {object} template
     */
    async onClickPrintDocumentButton(template) {
      const isDocument = !template.isContract;
      const isHasContractNumber = template.isHasNumberContractVariable;
      const isPatientContractsExists = this.patientContracts.length > 0;
      if (isDocument && isHasContractNumber && isPatientContractsExists) {
        this.isSelectContractNumberModal = true;
        const contractId = await new Promise((resolve) => {
          this.$once(NAME_EVENT_SELECTED_CONTRACT_NUMBER, (contract) => {
            resolve(contract);
          });
        });
        this.printDocument(template.templateId, contractId);
      } else {
        this.printDocument(template.templateId);
      }
    },
    /**
     * @description Обработать событие нажатия на кнопку скачать.
     * @param {object} template
     */
    async onClickDownloadDocumentButton(template) {
      const isDocument = !template.isContract;
      const isHasContractNumber = template.isHasNumberContractVariable
        ?? template.isNeedContractNumber;
      const isPatientContractsExists = this.patientContracts.length > 0;
      if (isDocument && isHasContractNumber && isPatientContractsExists) {
        this.isSelectContractNumberModal = true;
        const contractId = await new Promise((resolve) => {
          this.$once(NAME_EVENT_SELECTED_CONTRACT_NUMBER, (contract) => {
            resolve(contract);
          });
        });
        this.downloadDocument(template, contractId);
      } else {
        this.downloadDocument(template);
      }
    },
    /**
     * @description Печать документа.
     * @param {number} templateId Идентификатор шаблона.
     * @param {string} contractId Идентификатор договора.
     * @returns {void}
     */
    async printDocument(templateId, contractId = '') {
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = (response) => {
        const container = this.$refs.pdfView;
        container.setAttribute('src', URL.createObjectURL(response));
        container.onload = () => {
          container.contentWindow.print();
        };
      };
      const response = await this.$patientGateway.generateDocumentFromTemplateForPrint(
        this.patientId,
        templateId,
        contractId,
      );
      response.fold(onFail, onSuccess);
    },
    /**
     * @description Показать персональные данные пациента.
     * @returns {void}
     */
    showPatientPersonalData() {
      this.$patientGateway.getIdentification(this.patientId).then((result) => {
        result.forEach((data) => {
          this.inputErrors = {};
          this.identification = data;
          this.showForm = true;
        });
        result.forEachFail(({ title }) => {
          this.notifyFail(title);
        });
      });
    },
    /**
     * @description Скопировать адрес прописки в адрес проживания
     */
    copyAddressToLivingAddress() {
      this.identification.livingAddress = this.identification.address;
    },
    /**
     * @description Отправить запрос на изменение удостоверения личности.
     * @returns {Promise<Validation>}
     */
    async sendIdentificationEditRequest() {
      const request = new EditPatientIdentificationRequest(this.identification, this.patientId);
      const result = await this.$patientGateway.editIdentification(request);
      result.forEach(() => {
        this.identification.refresh();
        this.isIdentificationChanged = false;
      });

      return result;
    },
    /**
     * @description Отправить запрос на изменение удостоверения личности по иностранному паспорту.
     * @returns {Promise<Validation>}
     */
    async sendIdentificationForeignPasswordEditRequest() {
      const request = new EditPatientIdentificationForeignPasswordRequest(
        this.identification,
        this.patientId,
      );
      const result = await this.$patientGateway.editIdentification(request);
      result.forEach(() => {
        this.identification.refresh();
        this.isIdentificationChanged = false;
      });
      return result;
    },
    /**
     * @description Подписать выбранный файла.
     * @param {String} type Тип документа.
     * @param {Object} template Документ.
     * @returns {void}
     */
    signFile(type, template) {
      if (type === DOCUMENT_TYPE_DOCUMENT) {
        this.signDocument(template);
      }
      if (type === DOCUMENT_TYPE_CONTRACT) {
        this.signContract(template);
      }
      if (type === DOCUMENT_TYPE_PACKAGE) {
        if (!template.hasAllContractNumbersFilled()) {
          this.notifyFail('Укажите № Договора для всех документов Пакета!');
          return;
        }
        this.signPackage(template);
      }
    },
    /**
     * @description Отправка документа на подпись
     * @param {object} template
     */
    async signDocument(template) {
      if (this.isDocumentCanBeSent()) {
        const isDocument = !template.isContract;
        const isHasContractNumber = template.isHasNumberContractVariable;
        const isPatientContractsExists = this.patientContracts.length > 0;
        if (isDocument && isHasContractNumber && isPatientContractsExists) {
          this.isSelectContractNumberModal = true;
          const contractId = await new Promise((resolve) => {
            this.$once(NAME_EVENT_SELECTED_CONTRACT_NUMBER, (contract) => {
              resolve(contract);
            });
          });
          this.generateDocumentAndSign(template, contractId);
        } else {
          this.generateDocumentAndSign(template);
        }
      }
    },
    /**
     * @description Отправка контракта на подпись
     * @param {Object} template Шаблон договора.
     */
    async signContract(template) {
      if (this.isDocumentCanBeSent()) {
        this.isAwaitSignRequest = true;
        const onFail = (error) => {
          this.notifyFail(error.title);
          this.isAwaitSignRequest = false;
        };
        const onSuccess = (response) => {
          this.notifySuccess(response.title);
          this.isAwaitSignRequest = false;
          this.fetchPatientTemplates();
        };
        const response = await this.$fDocIntegrationGateway.generateContractFromTemplateForSign(
          template.id,
          template.number,
        );
        response.fold(onFail, onSuccess);
      }
    },
    /**
     * @description Отправка Пакета документов/контрактов на подпись
     * @param {Object} template Шаблон договора.
     */
    async signPackage(template) {
      if (this.isDocumentCanBeSent()) {
        this.isAwaitSignRequest = true;
        const onFail = (error) => {
          this.notifyFail(error.title);
          this.isAwaitSignRequest = false;
        };
        const onSuccess = (response) => {
          this.notifySuccess(response.title);
          this.isAwaitSignRequest = false;
          this.fetchPatientTemplates();
        };
        const response = await this
          .$fDocIntegrationGateway
          .generatePackageFromTemplateForSign(template);
        response.fold(onFail, onSuccess);
      }
    },
    /**
     * @description Проверка. Может ли сотрудник отправить документ на подпись.
     * (не сможет - если у пациента отсутствует номер телефона)
     */
    isDocumentCanBeSent() {
      if (!this.isPatientPhoneExists) {
        this.notifyFail('Подписание документа невозможно, без номера телефона пациента');
        return false;
      }
      return true;
    },
    /**
     * @description Сохранить файл.
     * @param {any}    file Файл.
     * @param {string} name Наименование.
     */
    saveArchive(file, name) {
      const obj = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = obj;
      link.target = '_blank';
      link.download = name;
      link.click();
      URL.revokeObjectURL(link.href);
      link.remove();
    },
  },
  helpTextGlobalDocument,
  mixins: [
    formNdlMixin,
    templatesMixin,
    notifierMixin,
    saveFileMixin,
    mobileMixin,
    builtInDialogMixin,
    metricMixin,
    dateMixin,
  ],
  name: 'ClinicPanelPatientDocuments',
  watch: {
    searchQuery: {
      handler: 'debounceFetchPatientTemplates',
    },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";
@use "@/scss/fields";
.padding {
  padding-left: 20px;
}
.contract-number-modal {
  .modal-dialog {
    overflow-y: auto;
  }
}
.patient-documents {
  &__search {
    max-width: 615px;
    margin-bottom: 20px;
  }
  &__table {
    counter-reset: counterEmployees;
    overflow-x: auto;
    &:empty {
      display: none;
    }
    &__head,
    &__row {
      display: grid;
      grid-gap: 4px;
      align-items: center;
      min-width: 1100px;
      font-size: 14px;
      line-height: 17px;
      &.with-status {
        grid-template-columns: 250px 1fr 160px 160px 320px 40px;
      }
      &.without-status {
        grid-template-columns: 250px 1fr 160px 320px 40px;
      }
    }
    &__row {
      width: 100%;
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
      padding: 10px 0;
    }
    &__row {
      border-bottom: 1px solid #eaeff3;
      padding: 12px 0;
    }
    &__cell {
      text-align: left;
      margin: 0 8px;
      &.selected {
        color: var(--action-color);
      }
      &.sort {
        text-align: left;
        cursor: pointer;
        display: flex;
        align-items: baseline;
        &:after {
          content: '';
          background-image: url("@/assets/img/checked/checked-grey.svg");
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          width: 10px;
          height: 10px;
          margin: 0 0 0 10px;
        }
        &:hover {
          text-decoration: none;
        }
      }
    }
    &__button-toggle {
      text-align: left !important;
      &:hover {
        color: var(--action-color);
      }
    }
    .cell-documents-extended {
      &__label {
        position: relative;
        display: flex;
        align-items: center;
        &::before {
          content: attr(data-sign);
          position: absolute;
          top: 50%;
          padding-inline: 10px;
          transform: translateY(-50%);
        }
      }
      &__input {
        @include fields.input-field;
        padding-left: 30px;
        height: 32px;
        max-width: 130px;
      }
    }
    &__buttons {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      justify-self: end;
      gap: 8px;
      width: min(100%, 355px);
    }
    &__button-download {
      display: flex;
      align-items: center;
      width: 24px;
      height: 24px;
      margin-inline: 8px;
      background: no-repeat 50%;
      background-image: url("@/assets/img/download/download-arrow-blue.svg");
      background-size: contain;
      &:disabled {
        background-image: url("@/assets/img/download/download-arrow-grey.svg");
        cursor: not-allowed
      }
      &--package {
        margin-right: 51px;
        @media screen and (max-width: 1100px) {
          margin-right: 9px;
        }
        @media screen and (max-width: 750px) {
          margin-right: 9px;
        }
      }
    }
    &__button-sign {
      @include buttons.btn-transparent(100%, 32px, 16px);
      max-width: 118px;
      &:disabled {
        background-color: var(--unfocus-color);
        border: 1px solid var(--unfocus-color);
        color: white;
        cursor: default;
      }
      &--package {
        margin-left: auto;
      }
    }
    &__button-print {
      display: flex;
      align-items: center;
      margin-inline: 8px 4px;
      &:before {
        content: "";
        background: no-repeat 50%;
        background-image: url("@/assets/img/print.svg");
        background-size: contain;
        width: 24px;
        height: 24px;
      }
      &:disabled::before {
        background-image: url("@/assets/img/print-grey.svg");
        cursor: not-allowed
      }
    }
    &__button-delete {
      display: flex;
      align-items: center;
      &:before {
        content: "";
        background: no-repeat 50%;
        background-image: url("@/assets/img/cross-blue.svg");
        background-size: contain;
        width: 24px;
        height: 24px;
      }
      &:disabled::before {
        background-image: url("@/assets/img/cross-grey.svg");
        cursor: not-allowed
      }
      &__disabled-grey {
        display: flex;
        align-items: center;
        &:before {
          content: "";
          background: no-repeat 50%;
          background-image: url("@/assets/img/cross-grey.svg");
          background-size: contain;
          width: 24px;
          height: 24px;
          cursor: not-allowed;
        }
      }
    }
  }
  &__support {
    background-color: transparent !important;
    padding: 0 !important;
    .support-contacts__caption,
    .support-contacts__tel,
    .support-contacts__email {
      font-size: 16px;
      line-height: 25px;
    }
    .support-contacts__button {
      font-size: 16px;
    }
  }
  &__form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 15px;
    margin-right: 10px;
    &__buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
      width: 100%;
      margin: 20px 0 0 0;
    }
    &__button-cancel {
      @include buttons.btn-transparent(100%, 56px, 20px);
    }
    &__button-submit {
      @include buttons.btn-blue(100%, 56px, 20px);
      &:disabled {
        background-color: var(--unfocus-color);
      }
    }
  }
  &__select {
    position: relative;
    width: 720px;
    max-width: 100%;
    &-input {
      padding: 0 42px;
      background: #ffffff;
      border: 1px solid #c2cfe0 !important;
      border-radius: 4px;
      outline: none;
      height: 40px;
      appearance: none;
      font-size: 16px;
      color: #192a3e;
      font-weight: 400;
      position: relative;
      width: 720px;
      max-width: 100%;
      &:focus {
        color: #192a3e;
        background-color: #fff;
        border: 2px solid #0489e0 !important;
        outline: 0;
      }
      &:disabled {
        background-color: #fff;
      }
    }
    &-icon-search {
      position: absolute;
      left: 12px;
      top: 10px;
      background-repeat: no-repeat;
      background-image: url("@/assets/img/search-black.svg");
      background-size: contain;
      width: 20px;
      height: 18px;
    }
    &-icon-file {
      position: absolute;
      right: 1px;
      top: 1px;
      background-repeat: no-repeat;
      background-image: url("@/assets/img/file.svg");
      background-position: center;
      background-color: #eaeff3;
      border-radius: 0 3px 3px 0;
      width: 36px;
      height: 38px;
    }
  }
  &__copy {
    &__button {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      margin: 0 0 2px 0;
      color: var(--unfocus-color);
      &:after {
        content: '';
        background-image: url("@/assets/img/copy-blue.svg");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: contain;
        margin: 0 0 0 10px;
        width: 15px;
        height: 15px;
      }
    }
  }
  &__buttons {
    display: grid;
    grid-template-columns: repeat(3, minmax(250px, 300px));
    grid-gap: 15px;
    margin: 30px 0 20px 0;
    @media screen and (max-width: 1100px) {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 20px 15px;
    }
    @media screen and (max-width: 750px) {
      grid-template-columns: 1fr;
    }
  }
  &__button-white {
    @include buttons.btn-transparent(100%, 56px, 16px);
    text-decoration: none;
    @media screen and (max-width: 1100px) {
      max-width: 400px;
    }
  }
  &__button-make {
    max-width: 400px;
    @include buttons.btn-blue(100%, 56px, 16px);
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
  &__info-need-completed {
    display: flex;
    align-items: center;
    margin-top: 15px;
    font-size: 16px;
    line-height: 25px;
    color: red !important;
    &.button-action {
      text-align: left;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
      &:disabled {
        color: var(--unfocus-color);
      }
    }
    &::before {
      content: "";
      background-image: url("@/assets/img/error.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0 10px 0 0;
      width: 25px;
      height: 25px;
    }
  }
  &__print {
    display: none;
  }
  &__ndfl-options {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &__violation {
      display: flex;
      flex-direction: column;
      align-items: center;
      &__text {
        color: var(--warning-color);
        font-size: 16px;
        padding-bottom: 40px;
        max-width: 600px;
      }
      &__button {
        @include buttons.btn-transparent(200px, 56px, 16px);
        text-decoration: none;
        @media screen and (max-width: 1100px) {
          max-width: 400px;
        }
      }
    }

    &__list {
      display: flex;
      flex-flow: row wrap;
      gap: 14px;
    }
    &__year {
      background-color: var(--fill-color);
      padding: 26px 43px;
      font-size: 20px;
      border-radius: 4px;

      &.selected {
        border: 2px solid var(--action-color);
        padding: 24px 41px;
      }
    }
    &__type {
      background-color: var(--fill-color);
      padding: 26px 43px;
      font-size: 20px;
      border-radius: 4px;

      &.selected {
        border: 2px solid var(--action-color);
        padding: 24px 41px;
      }
    }
  }
}

.documents-dialog {
  &__warning {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    column-gap: 10px;
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    color: red;
    text-decoration: underline;
    &::before {
      content: "";
      flex-shrink: 0;
      width: 25px;
      height: 25px;
      background-image: url("@/assets/img/error.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
  &__general-document {
    display: flex;
    align-items: center;
    align-self: flex-start;
    column-gap: 8px;
    padding-top: 5px;
  }
  &__checkbox {
    display: flex;
    align-items: center;
  }
}

.picker {
  &__item {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    &__button {
      max-width: 400px;
      text-align: left;
      transition: color 0.2s;
      > span.selected {
        color: #0569ac;
      }
      @media (hover: hover) {
        &:hover {
          color: #0076C4;
        }
      }
      &:active {
        color: #0569ac;
      }
    }
  }
}
</style>
